import superadminRoutes from "./SuperAdmin";

const superadminRoutesMap = {
  ...superadminRoutes,
};

export default superadminRoutesMap;
